/* LA CARTE DU YAMOUNA — modifier les plats et les prix ici (p = prix en euros) */
window.YAMOUNA_MENU = [
  {
    "id": "menus",
    "fr": "Menus",
    "en": "Set menus",
    "groups": [
      {
        "fr": "Le midi",
        "en": "Lunchtime",
        "note_fr": "Sauf samedi et jours fériés · boisson non comprise",
        "note_en": "Except Saturdays and public holidays · drink not included",
        "items": [
          {
            "n": "Menu Midi",
            "p": 12,
            "fr": [
              "Entrée : pakora, oignons bhaja ou raita",
              "Plat : bœuf curry, poulet curry, curry d'aubergine ou poulet tandoori, avec riz basmati",
              "Dessert : sorbet ou pâtisserie maison"
            ],
            "en": [
              "Starter: pakora, onion bhaji or raita",
              "Main: beef curry, chicken curry, aubergine curry or tandoori chicken, with basmati rice",
              "Dessert: sorbet or homemade pastry"
            ]
          },
          {
            "n": "Menu Midi Rapide",
            "p": 10,
            "fr": [
              "Assiette complète : poulet curry, dal et riz basmati"
            ],
            "en": [
              "Full plate: chicken curry, dal and basmati rice"
            ]
          },
          {
            "n": "Menu Enfant",
            "p": 10,
            "fr": [
              "3 morceaux de poulet tikka, frites, salade, fromage, riz basmati et sorbet"
            ],
            "en": [
              "3 pieces of chicken tikka, fries, salad, cheese, basmati rice and sorbet"
            ]
          }
        ]
      },
      {
        "fr": "Menus conseillés",
        "en": "Chef's set menus",
        "items": [
          {
            "n": "Menu Végétarien",
            "p": 16,
            "v": true,
            "fr": [
              "Entrée : raita, pakora ou samosa sabzi",
              "Plat : aloo sag panir, curry d'aubergine ou dal",
              "Dessert : sorbet ou pâtisserie maison"
            ],
            "en": [
              "Starter: raita, pakora or samosa sabzi",
              "Main: aloo sag paneer, aubergine curry or dal",
              "Dessert: sorbet or homemade pastry"
            ]
          },
          {
            "n": "Menu Non Végétarien",
            "p": 19,
            "fr": [
              "Entrée : poulet tandoori, entrée à l'agneau ou samosa keema",
              "Plat : poulet curry, agneau penjab, agneau curry ou crevettes curry",
              "Dessert : sorbet ou pâtisserie maison"
            ],
            "en": [
              "Starter: tandoori chicken, lamb starter or samosa keema",
              "Main: chicken curry, lamb penjab, lamb curry or prawn curry",
              "Dessert: sorbet or homemade pastry"
            ]
          },
          {
            "n": "Menu Gourmand",
            "p": 24,
            "fr": [
              "Entrée : assortiment, poulet tikka, agneau tikka ou mix grill",
              "Plat : poulet tikka massala, agneau tikka massala ou poulet korma",
              "Dessert au choix à la carte"
            ],
            "en": [
              "Starter: assortment, chicken tikka, lamb tikka or mixed grill",
              "Main: chicken tikka masala, lamb tikka masala or chicken korma",
              "Any dessert from the menu"
            ]
          }
        ]
      }
    ]
  },
  {
    "id": "entrees",
    "fr": "Entrées",
    "en": "Starters",
    "groups": [
      {
        "fr": "Les entrées",
        "en": "Starters",
        "items": [
          {
            "no": 1,
            "n": "Pakora",
            "p": 4,
            "v": true,
            "fr": "Beignets de légumes à la farine de pois chiche et aux épices",
            "en": "Vegetable fritters in a spiced chickpea batter"
          },
          {
            "no": 2,
            "n": "Oignons Bhaja",
            "p": 4,
            "v": true,
            "fr": "Beignets d'oignons à la farine de pois chiche et aux épices",
            "en": "Onion fritters in a spiced chickpea batter"
          },
          {
            "no": 3,
            "n": "Samosa Sabzi",
            "p": 4,
            "v": true,
            "fr": "Chaussons aux légumes, spécialité du Pendjab",
            "en": "Vegetable turnovers, a Punjabi speciality"
          },
          {
            "no": 4,
            "n": "Samosa Poulet",
            "p": 4,
            "fr": "Chaussons au poulet, spécialité indienne",
            "en": "Chicken turnovers, an Indian speciality"
          },
          {
            "no": 5,
            "n": "Samosa Keema",
            "p": 4,
            "fr": "Chaussons au bœuf haché, spécialité du Pendjab",
            "en": "Minced beef turnovers, a Punjabi speciality"
          },
          {
            "no": 6,
            "n": "Assortiment d'entrées",
            "p": 7,
            "fr": "Pakora, oignons bhaja, samosa sabzi et samosa keema",
            "en": "Pakora, onion bhaji, samosa sabzi and samosa keema"
          },
          {
            "no": 7,
            "n": "Crevettes Penjab",
            "p": 6,
            "fr": "Crevettes marinées, sauce mangue sucrée et épicée",
            "en": "Prawns marinated in a sweet and spicy mango sauce"
          },
          {
            "no": 8,
            "n": "Salade Raita",
            "p": 4,
            "v": true,
            "fr": "Yaourt aux épices, concombre, tomate et carotte",
            "en": "Spiced yoghurt with cucumber, tomato and carrot"
          },
          {
            "no": 9,
            "n": "Crevettes Raita",
            "p": 5.5,
            "fr": "Crevettes, yaourt aux épices, carotte, concombre et tomate",
            "en": "Prawns with spiced yoghurt, carrot, cucumber and tomato"
          }
        ]
      },
      {
        "fr": "Entrées tandoori",
        "en": "Tandoori starters",
        "note_fr": "Marinées puis cuites au four tandoor",
        "note_en": "Marinated, then cooked in the tandoor clay oven",
        "items": [
          {
            "no": 10,
            "n": "Poulet Tandoori",
            "p": 5,
            "fr": "Cuisse de poulet marinée",
            "en": "Marinated chicken leg"
          },
          {
            "no": 11,
            "n": "Poulet Tikka",
            "p": 6,
            "fr": "Blanc de poulet mariné",
            "en": "Marinated chicken breast"
          },
          {
            "no": 12,
            "n": "Agneau Tikka",
            "p": 6.5,
            "fr": "Morceaux d'agneau marinés",
            "en": "Marinated lamb pieces"
          },
          {
            "no": 13,
            "n": "Poisson Tikka",
            "p": 6,
            "fr": "Poisson mariné",
            "en": "Marinated fish"
          },
          {
            "no": 14,
            "n": "Agneau Kebab",
            "p": 5.5,
            "fr": "Brochette de viande hachée",
            "en": "Minced meat skewer"
          },
          {
            "no": 15,
            "n": "Gambas Tandoori",
            "p": 17,
            "fr": "Gambas marinées et grillées",
            "en": "Marinated grilled king prawns"
          },
          {
            "no": 16,
            "n": "Mix Grill · 1 pers.",
            "p": 10,
            "fr": "Assortiment de grillades tandoori",
            "en": "Tandoori grill assortment, for one"
          },
          {
            "no": 17,
            "n": "Mix Grill · 2 pers.",
            "p": 18,
            "fr": "Assortiment de grillades tandoori à partager",
            "en": "Tandoori grill assortment, to share"
          }
        ]
      }
    ]
  },
  {
    "id": "plats",
    "fr": "Plats",
    "en": "Mains",
    "groups": [
      {
        "fr": "Poulet",
        "en": "Chicken",
        "items": [
          {
            "no": 44,
            "n": "Poulet Curry",
            "p": 11.5,
            "fr": "Morceaux de poulet désossés, sauce curry",
            "en": "Boneless chicken in curry sauce"
          },
          {
            "no": 45,
            "n": "Poulet Vindaloo",
            "p": 12.5,
            "hot": 1,
            "fr": "Sauce épicée et pommes de terre",
            "en": "Spicy sauce with potatoes"
          },
          {
            "no": 46,
            "n": "Poulet Madras",
            "p": 12,
            "hot": 2,
            "fr": "Sauce Madras très relevée",
            "en": "Very hot Madras sauce"
          },
          {
            "no": 47,
            "n": "Butter Chicken",
            "p": 13,
            "star": true,
            "fr": "Blanc de poulet grillé au tandoor, crème fraîche et noix de cajou",
            "en": "Tandoor-grilled chicken breast, cream and cashew nuts"
          },
          {
            "no": 48,
            "n": "Poulet Massala",
            "p": 12.5,
            "fr": "Épices, oignons, tomates et poivrons verts",
            "en": "Spices, onions, tomatoes and green peppers"
          },
          {
            "no": 49,
            "n": "Poulet Tikka Massala",
            "p": 13,
            "star": true,
            "fr": "Blanc de poulet mariné et grillé au tandoor, sauce aux légumes",
            "en": "Marinated tandoor-grilled chicken breast in a vegetable sauce"
          },
          {
            "no": 50,
            "n": "Poulet Penjab",
            "p": 13.5,
            "fr": "Cuisse marinée au tandoor, sauce tomate",
            "en": "Tandoor-marinated chicken leg, tomato sauce"
          },
          {
            "no": 51,
            "n": "Poulet Korma",
            "p": 12.5,
            "fr": "Sauce noix de cajou, raisins secs et crème fraîche",
            "en": "Cashew sauce with raisins and cream"
          },
          {
            "no": 52,
            "n": "Poulet Dal",
            "p": 13,
            "fr": "Aux lentilles indiennes",
            "en": "With Indian lentils"
          },
          {
            "no": 53,
            "n": "Poulet Sag",
            "p": 13,
            "fr": "Aux épinards et aux épices",
            "en": "With spinach and spices"
          },
          {
            "no": 54,
            "n": "Poulet Jal Piazza",
            "p": 13,
            "hot": 1,
            "fr": "Plat relevé aux oignons et poivrons",
            "en": "Hot dish with onions and peppers"
          },
          {
            "no": 55,
            "n": "Poulet Tikka",
            "p": 13,
            "fr": "Blanc de poulet mariné, grillé au tandoor",
            "en": "Marinated tandoor-grilled chicken breast"
          },
          {
            "no": 56,
            "n": "Poulet Tandoori",
            "p": 13,
            "fr": "Cuisse de poulet marinée, cuite au tandoor",
            "en": "Marinated tandoor-cooked chicken leg"
          }
        ]
      },
      {
        "fr": "Agneau",
        "en": "Lamb",
        "items": [
          {
            "no": 57,
            "n": "Agneau Curry",
            "p": 12.5,
            "fr": "Gigot d'agneau, sauce curry",
            "en": "Leg of lamb in curry sauce"
          },
          {
            "no": 58,
            "n": "Agneau Korma",
            "p": 13,
            "fr": "Noix de cajou et raisins secs",
            "en": "Cashew nuts and raisins"
          },
          {
            "no": 59,
            "n": "Agneau Chili",
            "p": 13.5,
            "hot": 2,
            "fr": "Sauce très relevée et petits pois",
            "en": "Very hot sauce with green peas"
          },
          {
            "no": 60,
            "n": "Agneau Madras",
            "p": 13,
            "hot": 2,
            "fr": "Sauce Madras très relevée",
            "en": "Very hot Madras sauce"
          },
          {
            "no": 61,
            "n": "Agneau Vindaloo",
            "p": 13.5,
            "hot": 1,
            "fr": "Sauce épicée et pommes de terre",
            "en": "Spicy sauce with potatoes"
          },
          {
            "no": 62,
            "n": "Agneau Sagwala",
            "p": 13.5,
            "fr": "Sauce curry et épinards",
            "en": "Curry sauce with spinach"
          },
          {
            "no": 63,
            "n": "Agneau Bangan",
            "p": 13.5,
            "fr": "Sauce curry et aubergine",
            "en": "Curry sauce with aubergine"
          },
          {
            "no": 64,
            "n": "Agneau Dal",
            "p": 13.5,
            "fr": "Sauce curry et lentilles",
            "en": "Curry sauce with lentils"
          },
          {
            "no": 65,
            "n": "Agneau Tikka Massala",
            "p": 13.5,
            "fr": "Agneau grillé au tandoor, sauce aux légumes",
            "en": "Tandoor-grilled lamb in a vegetable sauce"
          },
          {
            "no": 66,
            "n": "Agneau Kebab",
            "p": 13,
            "fr": "Brochette de viande hachée grillée au tandoor",
            "en": "Tandoor-grilled minced meat skewer"
          },
          {
            "no": 67,
            "n": "Agneau Penjab",
            "p": 13.5,
            "fr": "Mariné aux épices, sauce tomate",
            "en": "Spice-marinated, tomato sauce"
          }
        ]
      },
      {
        "fr": "Bœuf",
        "en": "Beef",
        "items": [
          {
            "no": 68,
            "n": "Bœuf Curry",
            "p": 12,
            "fr": "Sauce curry",
            "en": "Curry sauce"
          },
          {
            "no": 69,
            "n": "Bœuf Madras",
            "p": 12.5,
            "hot": 2,
            "fr": "Sauce Madras très relevée",
            "en": "Very hot Madras sauce"
          },
          {
            "no": 70,
            "n": "Bœuf Vindaloo",
            "p": 13,
            "hot": 1,
            "fr": "Sauce curry épicée et pommes de terre",
            "en": "Spicy curry sauce with potatoes"
          },
          {
            "no": 71,
            "n": "Bœuf Dal",
            "p": 13,
            "fr": "Sauce curry et lentilles",
            "en": "Curry sauce with lentils"
          },
          {
            "no": 72,
            "n": "Bœuf Massala",
            "p": 13,
            "fr": "Sauce curry aux légumes",
            "en": "Curry sauce with vegetables"
          },
          {
            "no": 73,
            "n": "Keema Matar",
            "p": 13,
            "fr": "Agneau haché aux petits pois",
            "en": "Minced lamb with green peas"
          }
        ]
      },
      {
        "fr": "Crevettes & poisson",
        "en": "Prawns & fish",
        "items": [
          {
            "no": 74,
            "n": "Crevettes Curry",
            "p": 12,
            "fr": "Crevettes décortiquées, sauce curry",
            "en": "Peeled prawns in curry sauce"
          },
          {
            "no": 75,
            "n": "Crevettes Massala",
            "p": 12.5,
            "hot": 2,
            "fr": "Sauce curry très relevée",
            "en": "Very hot curry sauce"
          },
          {
            "no": 76,
            "n": "Crevettes Korma",
            "p": 13,
            "fr": "Sauce noix de cajou et crème fraîche",
            "en": "Cashew and cream sauce"
          },
          {
            "no": 77,
            "n": "Poisson Curry",
            "p": 12.5,
            "fr": "Filet de saumon, sauce curry",
            "en": "Salmon fillet in curry sauce"
          },
          {
            "no": 78,
            "n": "Poisson Tikka Massala",
            "p": 13,
            "fr": "Filet mariné au tandoor, sauce aux légumes",
            "en": "Tandoor-marinated fillet in a vegetable sauce"
          }
        ]
      }
    ]
  },
  {
    "id": "veg",
    "fr": "Végétarien",
    "en": "Vegetarian",
    "groups": [
      {
        "fr": "Spécialités végétariennes",
        "en": "Vegetarian specialities",
        "items": [
          {
            "no": 79,
            "n": "Aloo Bombay",
            "p": 10,
            "v": true,
            "hot": 1,
            "fr": "Curry de pommes de terre relevé",
            "en": "Hot potato curry"
          },
          {
            "no": 80,
            "n": "Curry d'Aubergine",
            "p": 10,
            "v": true,
            "fr": "Aubergines au curry",
            "en": "Aubergine curry"
          },
          {
            "no": 81,
            "n": "Matar Panir",
            "p": 10,
            "v": true,
            "fr": "Petits pois et fromage indien",
            "en": "Green peas and Indian cheese"
          },
          {
            "no": 82,
            "n": "Aloo Sag Panir",
            "p": 10,
            "v": true,
            "fr": "Épinards, pommes de terre et fromage indien",
            "en": "Spinach, potatoes and Indian cheese"
          },
          {
            "no": 83,
            "n": "Dal",
            "p": 10,
            "v": true,
            "fr": "Lentilles, recette traditionnelle",
            "en": "Lentils, traditional recipe"
          },
          {
            "no": 84,
            "n": "Aloo Matar",
            "p": 10,
            "v": true,
            "fr": "Petits pois et pommes de terre",
            "en": "Green peas and potatoes"
          },
          {
            "no": 89,
            "n": "Biryani Légumes",
            "p": 12.5,
            "v": true,
            "fr": "Légumes, riz basmati et épices",
            "en": "Vegetables, basmati rice and spices"
          }
        ]
      }
    ]
  },
  {
    "id": "biryani",
    "fr": "Biryani, riz & nans",
    "en": "Biryani, rice & naans",
    "groups": [
      {
        "fr": "Biryani",
        "en": "Biryani",
        "note_fr": "Riz basmati cuit avec la viande et les épices",
        "note_en": "Basmati rice cooked with the meat and spices",
        "items": [
          {
            "no": 85,
            "n": "Biryani Poulet",
            "p": 13.5,
            "fr": "Poulet, riz et épices",
            "en": "Chicken, rice and spices"
          },
          {
            "no": 86,
            "n": "Biryani Agneau",
            "p": 14,
            "fr": "Gigot d'agneau, riz et épices",
            "en": "Leg of lamb, rice and spices"
          },
          {
            "no": 87,
            "n": "Biryani Crevettes",
            "p": 14,
            "fr": "Crevettes, riz et épices",
            "en": "Prawns, rice and spices"
          },
          {
            "no": 88,
            "n": "Biryani Bœuf",
            "p": 14,
            "fr": "Bœuf, riz et épices",
            "en": "Beef, rice and spices"
          },
          {
            "no": 89,
            "n": "Biryani Légumes",
            "p": 12.5,
            "v": true,
            "fr": "Légumes, riz et épices",
            "en": "Vegetables, rice and spices"
          },
          {
            "no": 90,
            "n": "Mix Biryani",
            "p": 18,
            "fr": "Agneau, poulet et crevettes",
            "en": "Lamb, chicken and prawns"
          }
        ]
      },
      {
        "fr": "Riz basmati",
        "en": "Basmati rice",
        "items": [
          {
            "no": 91,
            "n": "Riz Pullao",
            "p": 2.5,
            "v": true,
            "fr": "Riz basmati parfumé",
            "en": "Fragrant basmati rice"
          },
          {
            "no": 92,
            "n": "Peas Pullao",
            "p": 6,
            "v": true,
            "fr": "Riz aux petits pois et aux épices",
            "en": "Rice with green peas and spices"
          }
        ]
      },
      {
        "fr": "Pains du tandoor",
        "en": "Tandoor breads",
        "items": [
          {
            "no": 93,
            "n": "Chapati",
            "p": 2,
            "v": true,
            "fr": "Pain de blé complet",
            "en": "Wholewheat flatbread"
          },
          {
            "no": 94,
            "n": "Nan",
            "p": 2,
            "v": true,
            "fr": "Galette de farine blanche",
            "en": "Plain white-flour naan"
          },
          {
            "no": 95,
            "n": "Nan Fromage",
            "p": 3,
            "v": true,
            "star": true,
            "fr": "Galette fourrée au fromage",
            "en": "Cheese-filled naan"
          },
          {
            "no": 96,
            "n": "Keema Nan",
            "p": 3.5,
            "fr": "Galette farcie à la viande hachée",
            "en": "Naan stuffed with minced meat"
          },
          {
            "no": 97,
            "n": "Prata Stuff",
            "p": 3.5,
            "v": true,
            "fr": "Nan farci aux légumes",
            "en": "Vegetable-stuffed naan"
          },
          {
            "no": 98,
            "n": "Garlic Nan",
            "p": 3,
            "v": true,
            "fr": "Nan à l'ail",
            "en": "Garlic naan"
          }
        ]
      }
    ]
  },
  {
    "id": "desserts",
    "fr": "Desserts",
    "en": "Desserts",
    "groups": [
      {
        "fr": "Desserts",
        "en": "Desserts",
        "items": [
          {
            "no": 99,
            "n": "Halwa",
            "p": 4,
            "fr": "Gâteau de semoule, amandes et noix de coco",
            "en": "Semolina cake with almonds and coconut"
          },
          {
            "no": 100,
            "n": "Gulab Jamun",
            "p": 4,
            "fr": "Beignets de lait, sirop à la rose et à la cardamome",
            "en": "Milk dumplings in rose and cardamom syrup"
          },
          {
            "no": 101,
            "n": "Kulfi",
            "p": 4,
            "fr": "Glace maison à la pistache, sirop de rose",
            "en": "Homemade pistachio ice cream, rose syrup"
          },
          {
            "no": 102,
            "n": "Mangue fraîche",
            "p": 5,
            "fr": "",
            "en": "Fresh mango"
          },
          {
            "no": 103,
            "n": "Salade de fruits",
            "p": 4,
            "fr": "",
            "en": "Fruit salad"
          },
          {
            "no": 104,
            "n": "Secret vanille meringue",
            "p": 4,
            "fr": "",
            "en": "Vanilla meringue dessert"
          },
          {
            "no": 105,
            "n": "Nougat glacé",
            "p": 5,
            "fr": "Nougat glacé à la pulpe de mangue",
            "en": "Iced nougat with mango pulp"
          },
          {
            "no": 106,
            "n": "Colonel",
            "p": 6,
            "fr": "Sorbet citron vert et vodka",
            "en": "Lime sorbet with vodka"
          },
          {
            "no": 107,
            "n": "Sorbet ou glace · 2 boules",
            "p": 3,
            "fr": "Mangue, citron vert, framboise, pistache, coco, vanille, chocolat ou nougat",
            "en": "Mango, lime, raspberry, pistachio, coconut, vanilla, chocolate or nougat"
          }
        ]
      }
    ]
  },
  {
    "id": "boissons",
    "fr": "Boissons",
    "en": "Drinks",
    "groups": [
      {
        "fr": "Boissons indiennes & softs",
        "en": "Indian drinks & soft drinks",
        "items": [
          {
            "n": "Lassi",
            "p": 3.5,
            "fr": "Boisson au yaourt : nature, salé, sucré, rose, mangue ou banane",
            "en": "Yoghurt drink: plain, salted, sweet, rose, mango or banana"
          },
          {
            "n": "Lembo Pani",
            "p": 2.5,
            "fr": "Limonade à la rose",
            "en": "Rose lemonade"
          },
          {
            "n": "Jus de mangue, ananas ou orange",
            "p": 3,
            "fr": "",
            "en": "Mango, pineapple or orange juice"
          },
          {
            "n": "Coca-Cola, Coca-Cola Zéro, Orangina, Schweppes, Ice Tea",
            "p": 3,
            "fr": "",
            "en": ""
          },
          {
            "n": "Perrier",
            "p": 3,
            "fr": "",
            "en": ""
          },
          {
            "n": "Badoit ou Vittel · 50 cl",
            "p": 2.5,
            "fr": "",
            "en": ""
          },
          {
            "n": "Badoit ou Vittel · 1 L",
            "p": 4,
            "fr": "",
            "en": ""
          }
        ]
      },
      {
        "fr": "Bières & apéritifs",
        "en": "Beers & aperitifs",
        "items": [
          {
            "n": "Bière indienne · 33 cl",
            "p": 4,
            "fr": "",
            "en": "Indian beer"
          },
          {
            "n": "Heineken ou Kronenbourg · 25 cl",
            "p": 3,
            "fr": "",
            "en": ""
          },
          {
            "n": "Cocktail maison",
            "p": 5,
            "fr": "",
            "en": "House cocktail"
          },
          {
            "n": "Martini, Porto, Ricard",
            "p": 3.5,
            "fr": "",
            "en": ""
          },
          {
            "n": "Kir",
            "p": 3,
            "fr": "",
            "en": ""
          },
          {
            "n": "Whisky",
            "p": 5.5,
            "fr": "",
            "en": ""
          }
        ]
      },
      {
        "fr": "Boissons chaudes",
        "en": "Hot drinks",
        "items": [
          {
            "n": "Thé maison",
            "p": 3,
            "fr": "Thé au lait et aux épices",
            "en": "Spiced milk tea"
          },
          {
            "n": "Thé à la cardamome",
            "p": 2.5,
            "fr": "",
            "en": "Cardamom tea"
          },
          {
            "n": "Thé à la menthe",
            "p": 2.5,
            "fr": "",
            "en": "Mint tea"
          },
          {
            "n": "Thé nature",
            "p": 2,
            "fr": "",
            "en": "Plain tea"
          },
          {
            "n": "Café",
            "p": 2,
            "fr": "",
            "en": "Coffee"
          }
        ]
      }
    ]
  }
];
